module.exports = __webpack_public_path__ + "img/AGR-B-2-I.b8565a7e.png";